interface IEnglishIqV2ProgressProps {
  answered: number;
  label: string;
  total: number;
}

export function EnglishIqV2Progress({
  answered,
  label,
  total,
}: IEnglishIqV2ProgressProps): React.JSX.Element {
  const frames = Array.from({ length: total }, (_, index) => ({
    frameId: `frame-${index + 1}`,
    index,
  }));
  return (
    <div className="mb-6 sm:mb-8">
      <div className="mb-3 flex items-center justify-between gap-4 text-xs font-bold uppercase tracking-[0.18em] text-[#f7edda]/55">
        <span>{label}</span>
        <span aria-live="polite">
          {answered}/{total}
        </span>
      </div>
      <div
        aria-label={label}
        aria-valuemax={total}
        aria-valuemin={0}
        aria-valuenow={answered}
        className="grid grid-cols-12 gap-1.5"
        role="progressbar"
      >
        {frames.map(({ frameId, index }) => (
          <span
            className={`h-2 rounded-[2px] border sm:h-2.5 ${
              index < answered
                ? 'border-[#ff7a1a] bg-[#ff7a1a]'
                : index === answered
                  ? 'border-[#ffb36b] bg-[#ff7a1a]/25'
                  : 'border-[#f7edda]/15 bg-[#f7edda]/5'
            }`}
            key={frameId}
          />
        ))}
      </div>
    </div>
  );
}
